import {
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Grid
} from '@material-ui/core'
import { Field, Form, Formik } from 'formik'
import { useEffect, useState } from 'react'
import { ButtonPrimary } from '../ButtonPrimary'
import { ButtonSecondary } from '../ButtonSecondary'
import { InputFieldText } from '../InputFieldText'
import { InputSwitch } from '../InputSwitch'
import { i18n } from '../../translate/i18n'
import { useStyles } from './styles'

const DEFAULT_START_TIME = '08:00'
const DEFAULT_END_TIME = '18:00'
const DEFAULT_LUNCH_START_TIME = '12:00'
const DEFAULT_LUNCH_END_TIME = '13:00'

const DAYS_OF_WEEK = [
  { label: 'Seg', index: 0 },
  { label: 'Ter', index: 1 },
  { label: 'Qua', index: 2 },
  { label: 'Qui', index: 3 },
  { label: 'Sex', index: 4 },
  { label: 'Sáb', index: 5 },
  { label: 'Dom', index: 6 }
]

const ScheduleQueueModal = ({
  open,
  onClose,
  schedules: initialSchedules,
  onSubmit,
  loading,
  queueName
}) => {
  const classes = useStyles()

  const [weekStartTime, setWeekStartTime] = useState(DEFAULT_START_TIME)
  const [weekEndTime, setWeekEndTime] = useState(DEFAULT_END_TIME)
  const [launchTimeEnabled, setLaunchTimeEnabled] = useState(false)
  const [lunchWeekStartTime, setLunchWeekStartTime] = useState(
    DEFAULT_LUNCH_START_TIME
  )
  const [lunchWeekEndTime, setLunchWeekEndTime] = useState(
    DEFAULT_LUNCH_END_TIME
  )

  const [saturdayStartTime, setSaturdayStartTime] = useState(DEFAULT_START_TIME)
  const [saturdayEndTime, setSaturdayEndTime] = useState(DEFAULT_END_TIME)
  const [launchTimeSaturdayEnabled, setLaunchTimeSaturdayEnabled] =
    useState(false)
  const [lunchSaturdayStartTime, setLunchSaturdayStartTime] = useState(
    DEFAULT_LUNCH_START_TIME
  )
  const [lunchSaturdayEndTime, setLunchSaturdayEndTime] = useState(
    DEFAULT_LUNCH_END_TIME
  )

  const [sundayStartTime, setSundayStartTime] = useState(DEFAULT_START_TIME)
  const [sundayEndTime, setSundayEndTime] = useState(DEFAULT_END_TIME)
  const [launchTimeSundayEnabled, setLaunchTimeSundayEnabled] = useState(false)
  const [lunchSundayStartTime, setLunchSundayStartTime] = useState(
    DEFAULT_LUNCH_START_TIME
  )
  const [lunchSundayEndTime, setLunchSundayEndTime] = useState(
    DEFAULT_LUNCH_END_TIME
  )

  const [holidayDate, setHolidayDate] = useState('')
  const [holidayStartTime, setHolidayStartTime] = useState('')
  const [holidayEndTime, setHolidayEndTime] = useState('')
  const [holidaySwitchEnabled, setHolidaySwitchEnabled] = useState(false)

  useEffect(() => {
    if (initialSchedules && initialSchedules.length > 0) {
      const weekDay = initialSchedules.find(
        (s, i) => i >= 0 && i <= 4 && s.startTimeA
      )
      if (weekDay) {
        setWeekStartTime(weekDay.startTimeA)
        setWeekEndTime(weekDay.endTimeA)
      }

      const weekDayWithLunch = initialSchedules.find(
        (s, i) => i >= 0 && i <= 4 && s.checked && s.startTimeB && s.endTimeB
      )
      if (weekDayWithLunch) {
        setLaunchTimeEnabled(true)
        setLunchWeekStartTime(weekDayWithLunch.startTimeB)
        setLunchWeekEndTime(weekDayWithLunch.endTimeB)
      }

      const saturday = initialSchedules.find((s, i) => i === 5 && s.startTimeA)
      if (saturday) {
        setSaturdayStartTime(saturday.startTimeA)
        setSaturdayEndTime(saturday.endTimeA)
      }

      const saturdayWithLunch = initialSchedules.find(
        (s, i) => i === 5 && s.checked && s.startTimeB && s.endTimeB
      )
      if (saturdayWithLunch) {
        setLaunchTimeSaturdayEnabled(true)
        setLunchSaturdayStartTime(saturdayWithLunch.startTimeB)
        setLunchSaturdayEndTime(saturdayWithLunch.endTimeB)
      }

      const sunday = initialSchedules.find((s, i) => i === 6 && s.startTimeA)
      if (sunday) {
        setSundayStartTime(sunday.startTimeA)
        setSundayEndTime(sunday.endTimeA)
      }

      const sundayWithLunch = initialSchedules.find(
        (s, i) => i === 6 && s.checked && s.startTimeB && s.endTimeB
      )
      if (sundayWithLunch) {
        setLaunchTimeSundayEnabled(true)
        setLunchSundayStartTime(sundayWithLunch.startTimeB)
        setLunchSundayEndTime(sundayWithLunch.endTimeB)
      }
    }
  }, [initialSchedules])

  const handleClose = () => {
    onClose()
  }

  const days = [
    { label: 'Seg', index: 0 },
    { label: 'Ter', index: 1 },
    { label: 'Qua', index: 2 },
    { label: 'Qui', index: 3 },
    { label: 'Sex', index: 4 },
    { label: 'Sáb', index: 5 },
    { label: 'Dom', index: 6 }
  ]

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        className: classes.dialogPaper
      }}
    >
      <DialogTitle className={classes.dialogTitle}>
        Horário de Expediente por Departamento
      </DialogTitle>

      <Formik
        enableReinitialize
        initialValues={{ schedules: initialSchedules }}
        onSubmit={({ schedules }) =>
          setTimeout(() => {
            onSubmit(schedules)
          }, 500)
        }
      >
        {({ values, setFieldValue, submitForm }) => {
          const showWeekTime =
            values.schedules &&
            values.schedules.some(
              (s, index) => s.checked && index >= 0 && index <= 4
            )

          const showSaturdayTime =
            values.schedules &&
            values.schedules.some(
              (s, index) => s.checked && index >= 5 && index <= 5
            )

          const showSundayTime =
            values.schedules &&
            values.schedules.some(
              (s, index) => s.checked && index >= 6 && index <= 6
            )

          const handleDayToggle = (e, day, form) => {
            const isChecked = e.target.checked
            form.setFieldValue(`schedules[${day.index}].checked`, isChecked)

            if (!isChecked) {
              form.setFieldValue(`schedules[${day.index}].startTimeA`, '')
              form.setFieldValue(`schedules[${day.index}].endTimeA`, '')
              form.setFieldValue(`schedules[${day.index}].startTimeB`, '')
              form.setFieldValue(`schedules[${day.index}].endTimeB`, '')
              return
            }

            if (day.index >= 0 && day.index <= 4) {
              form.setFieldValue(
                `schedules[${day.index}].startTimeA`,
                weekStartTime || DEFAULT_START_TIME
              )
              form.setFieldValue(
                `schedules[${day.index}].endTimeA`,
                weekEndTime || DEFAULT_END_TIME
              )
              if (launchTimeEnabled) {
                form.setFieldValue(
                  `schedules[${day.index}].startTimeB`,
                  lunchWeekStartTime
                )
                form.setFieldValue(
                  `schedules[${day.index}].endTimeB`,
                  lunchWeekEndTime
                )
              }
            } else if (day.index === 5) {
              form.setFieldValue(
                `schedules[${day.index}].startTimeA`,
                saturdayStartTime || DEFAULT_START_TIME
              )
              form.setFieldValue(
                `schedules[${day.index}].endTimeA`,
                saturdayEndTime || DEFAULT_END_TIME
              )
              if (launchTimeSaturdayEnabled) {
                form.setFieldValue(
                  `schedules[${day.index}].startTimeB`,
                  lunchSaturdayStartTime
                )
                form.setFieldValue(
                  `schedules[${day.index}].endTimeB`,
                  lunchSaturdayEndTime
                )
              }
            } else if (day.index === 6) {
              form.setFieldValue(
                `schedules[${day.index}].startTimeA`,
                sundayStartTime || DEFAULT_START_TIME
              )
              form.setFieldValue(
                `schedules[${day.index}].endTimeA`,
                sundayEndTime || DEFAULT_END_TIME
              )
              if (launchTimeSundayEnabled) {
                form.setFieldValue(
                  `schedules[${day.index}].startTimeB`,
                  lunchSundayStartTime
                )
                form.setFieldValue(
                  `schedules[${day.index}].endTimeB`,
                  lunchSundayEndTime
                )
              }
            }
          }

          return (
            <Form>
              <DialogContent dividers>
                <Grid container className={classes.boxGrid}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} className={classes.contentFormGroup}>
                      <FormControl component="fieldset">
                        <FormLabel
                          component="legend"
                          className={classes.formLabel}
                        >
                          Selecione os dias que o departamento funciona
                        </FormLabel>
                        <FormGroup row>
                          {days.map(day => (
                            <Field
                              name={`schedules[${day.index}].checked`}
                              key={day.index}
                            >
                              {({ field, form }) => (
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      {...field}
                                      className={classes.checkbox}
                                      checked={field.value || false}
                                      // onChange={e => {
                                      //   const isChecked = e.target.checked
                                      //   form.setFieldValue(
                                      //     field.name,
                                      //     isChecked
                                      //   )
                                      //   if (isChecked) {
                                      //     if (
                                      //       day.index >= 0 &&
                                      //       day.index <= 4
                                      //     ) {
                                      //       form.setFieldValue(
                                      //         `schedules[${day.index}].startTimeA`,
                                      //         weekStartTime
                                      //       )
                                      //       form.setFieldValue(
                                      //         `schedules[${day.index}].endTimeA`,
                                      //         weekEndTime
                                      //       )
                                      //       if (launchTimeEnabled) {
                                      //         form.setFieldValue(
                                      //           `schedules[${day.index}].startTimeB`,
                                      //           lunchWeekStartTime
                                      //         )
                                      //         form.setFieldValue(
                                      //           `schedules[${day.index}].endTimeB`,
                                      //           lunchWeekEndTime
                                      //         )
                                      //       }
                                      //     } else if (day.index === 5) {
                                      //       form.setFieldValue(
                                      //         `schedules[${day.index}].startTimeA`,
                                      //         saturdayStartTime
                                      //       )
                                      //       form.setFieldValue(
                                      //         `schedules[${day.index}].endTimeA`,
                                      //         saturdayEndTime
                                      //       )
                                      //       if (launchTimeSaturdayEnabled) {
                                      //         form.setFieldValue(
                                      //           `schedules[${day.index}].startTimeB`,
                                      //           lunchSaturdayStartTime
                                      //         )
                                      //         form.setFieldValue(
                                      //           `schedules[${day.index}].endTimeB`,
                                      //           lunchSaturdayEndTime
                                      //         )
                                      //       }
                                      //     } else if (day.index === 6) {
                                      //       form.setFieldValue(
                                      //         `schedules[${day.index}].startTimeA`,
                                      //         sundayStartTime
                                      //       )
                                      //       form.setFieldValue(
                                      //         `schedules[${day.index}].endTimeA`,
                                      //         sundayEndTime
                                      //       )
                                      //       if (launchTimeSundayEnabled) {
                                      //         form.setFieldValue(
                                      //           `schedules[${day.index}].startTimeB`,
                                      //           lunchSundayStartTime
                                      //         )
                                      //         form.setFieldValue(
                                      //           `schedules[${day.index}].endTimeB`,
                                      //           lunchSundayEndTime
                                      //         )
                                      //       }
                                      //     }
                                      //   } else {
                                      //     form.setFieldValue(
                                      //       `schedules[${day.index}].startTimeA`,
                                      //       ''
                                      //     )
                                      //     form.setFieldValue(
                                      //       `schedules[${day.index}].endTimeA`,
                                      //       ''
                                      //     )
                                      //     form.setFieldValue(
                                      //       `schedules[${day.index}].startTimeB`,
                                      //       ''
                                      //     )
                                      //     form.setFieldValue(
                                      //       `schedules[${day.index}].endTimeB`,
                                      //       ''
                                      //     )
                                      //   }
                                      // }}
                                      onChange={e =>
                                        handleDayToggle(e, day, form)
                                      }
                                      color="primary"
                                    />
                                  }
                                  label={day.label}
                                  className={classes.formLabel}
                                />
                              )}
                            </Field>
                          ))}
                        </FormGroup>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} className={classes.contentFormGrid}>
                      <div
                        className={classes.boxShowWeekTime}
                        style={{
                          height: holidaySwitchEnabled ? 'auto' : '50px',
                          width: '254px'
                        }}
                      >
                        <FormControl className={classes.formControl}>
                          <InputSwitch
                            label="Ativar modo feriado"
                            size="small"
                            onChange={e => {
                              setHolidaySwitchEnabled(e.target.checked)
                            }}
                            checked={holidaySwitchEnabled}
                          />
                          {holidaySwitchEnabled && (
                            <>
                              <FormLabel
                                component="legend"
                                className={classes.formLabel}
                              >
                                Data e horário do feriado
                              </FormLabel>
                              <InputFieldText
                                type="date"
                                value={holidayDate}
                                onChange={e => {
                                  setHolidayDate(e.target.value)
                                }}
                                InputLabelProps={{
                                  shrink: true
                                }}
                              />
                              <div className={classes.inputWrapper}>
                                <InputFieldText
                                  type="time"
                                  value={holidayStartTime}
                                  onChange={e => {
                                    const newStartTime = e.target.value
                                    setHolidayStartTime(newStartTime)
                                    // Aplica o horário de feriado aos dias úteis marcados
                                    const newSchedules = values.schedules.map(
                                      (schedule, index) =>
                                        schedule.checked &&
                                        index >= 0 &&
                                        index <= 4
                                          ? {
                                              ...schedule,
                                              startTimeA: newStartTime
                                            }
                                          : schedule
                                    )
                                    setFieldValue('schedules', newSchedules)
                                    e.target.blur()
                                  }}
                                  InputLabelProps={{
                                    shrink: true
                                  }}
                                />
                                <span className={classes.textUntil}>até</span>
                                <InputFieldText
                                  type="time"
                                  value={holidayEndTime}
                                  onChange={e => {
                                    const newEndTime = e.target.value
                                    setHolidayEndTime(newEndTime)
                                    // Aplica o horário de feriado aos dias úteis marcados
                                    const newSchedules = values.schedules.map(
                                      (schedule, index) =>
                                        schedule.checked &&
                                        index >= 0 &&
                                        index <= 4
                                          ? {
                                              ...schedule,
                                              endTimeA: newEndTime
                                            }
                                          : schedule
                                    )
                                    setFieldValue('schedules', newSchedules)
                                    e.target.blur()
                                  }}
                                  InputLabelProps={{
                                    shrink: true
                                  }}
                                />
                              </div>
                            </>
                          )}
                        </FormControl>
                      </div>

                      {showWeekTime && (
                        <div
                          className={classes.boxShowWeekTime}
                          style={{
                            height: launchTimeEnabled ? 'auto' : '120px'
                          }}
                        >
                          <FormControl className={classes.formControl}>
                            <FormLabel
                              component="legend"
                              className={classes.formLabel}
                            >
                              Horário durante a semana
                            </FormLabel>
                            <div className={classes.inputWrapper}>
                              <InputFieldText
                                type="time"
                                value={weekStartTime}
                                onChange={e => {
                                  const newStartTime = e.target.value
                                  setWeekStartTime(newStartTime)
                                  const newSchedules = values.schedules.map(
                                    (schedule, index) =>
                                      schedule.checked &&
                                      index >= 0 &&
                                      index <= 4
                                        ? {
                                            ...schedule,
                                            startTimeA: newStartTime
                                          }
                                        : schedule
                                  )
                                  setFieldValue('schedules', newSchedules)
                                  e.target.blur()
                                }}
                                InputLabelProps={{
                                  shrink: true
                                }}
                              />
                              <span className={classes.textUntil}>até</span>
                              <InputFieldText
                                type="time"
                                value={weekEndTime}
                                onChange={e => {
                                  const newEndTime = e.target.value
                                  setWeekEndTime(newEndTime)
                                  const newSchedules = values.schedules.map(
                                    (schedule, index) =>
                                      schedule.checked &&
                                      index >= 0 &&
                                      index <= 4
                                        ? { ...schedule, endTimeA: newEndTime }
                                        : schedule
                                  )
                                  setFieldValue('schedules', newSchedules)
                                  e.target.blur()
                                }}
                                InputLabelProps={{
                                  shrink: true
                                }}
                              />
                            </div>
                            <InputSwitch
                              label="Adicionar horário de almoço"
                              size="small"
                              onChange={e => {
                                const isEnabled = e.target.checked
                                setLaunchTimeEnabled(isEnabled)
                                const newSchedules = values.schedules.map(
                                  (schedule, index) => {
                                    if (
                                      schedule.checked &&
                                      index >= 0 &&
                                      index <= 4
                                    ) {
                                      return {
                                        ...schedule,
                                        startTimeB: isEnabled
                                          ? lunchWeekStartTime
                                          : '',
                                        endTimeB: isEnabled
                                          ? lunchWeekEndTime
                                          : ''
                                      }
                                    }
                                    return schedule
                                  }
                                )
                                setFieldValue('schedules', newSchedules)
                              }}
                              checked={launchTimeEnabled}
                            />
                            {launchTimeEnabled && (
                              <div className={classes.inputWrapper}>
                                <InputFieldText
                                  type="time"
                                  value={lunchWeekStartTime}
                                  onChange={e => {
                                    const newStartTime = e.target.value
                                    setLunchWeekStartTime(newStartTime)
                                    const newSchedules = values.schedules.map(
                                      (schedule, index) =>
                                        schedule.checked &&
                                        index >= 0 &&
                                        index <= 4
                                          ? {
                                              ...schedule,
                                              startTimeB: newStartTime
                                            }
                                          : schedule
                                    )
                                    setFieldValue('schedules', newSchedules)
                                    e.target.blur()
                                  }}
                                  InputLabelProps={{
                                    shrink: true
                                  }}
                                />
                                <span className={classes.textUntil}>até</span>
                                <InputFieldText
                                  type="time"
                                  value={lunchWeekEndTime}
                                  onChange={e => {
                                    const newEndTime = e.target.value
                                    setLunchWeekEndTime(newEndTime)
                                    const newSchedules = values.schedules.map(
                                      (schedule, index) =>
                                        schedule.checked &&
                                        index >= 0 &&
                                        index <= 4
                                          ? {
                                              ...schedule,
                                              endTimeB: newEndTime
                                            }
                                          : schedule
                                    )
                                    setFieldValue('schedules', newSchedules)
                                    e.target.blur()
                                  }}
                                  InputLabelProps={{
                                    shrink: true
                                  }}
                                />
                              </div>
                            )}
                          </FormControl>
                        </div>
                      )}

                      {showSaturdayTime && (
                        <div
                          className={classes.boxShowWeekTime}
                          style={{
                            height: launchTimeSaturdayEnabled ? 'auto' : '120px'
                          }}
                        >
                          <FormControl className={classes.formControl}>
                            <FormLabel
                              component="legend"
                              className={classes.formLabel}
                            >
                              Horário durante os sábados
                            </FormLabel>
                            <div className={classes.inputWrapper}>
                              <InputFieldText
                                type="time"
                                value={saturdayStartTime}
                                onChange={e => {
                                  const newStartTime = e.target.value
                                  setSaturdayStartTime(newStartTime)
                                  const newSchedules = values.schedules.map(
                                    (schedule, index) =>
                                      schedule.checked && index === 5
                                        ? {
                                            ...schedule,
                                            startTimeA: newStartTime
                                          }
                                        : schedule
                                  )
                                  setFieldValue('schedules', newSchedules)
                                  e.target.blur()
                                }}
                                InputLabelProps={{
                                  shrink: true
                                }}
                              />
                              <span className={classes.textUntil}>até</span>
                              <InputFieldText
                                type="time"
                                value={saturdayEndTime}
                                onChange={e => {
                                  const newEndTime = e.target.value
                                  setSaturdayEndTime(newEndTime)
                                  const newSchedules = values.schedules.map(
                                    (schedule, index) =>
                                      schedule.checked && index === 5
                                        ? { ...schedule, endTimeA: newEndTime }
                                        : schedule
                                  )
                                  setFieldValue('schedules', newSchedules)
                                  e.target.blur()
                                }}
                                InputLabelProps={{
                                  shrink: true
                                }}
                              />
                            </div>
                            <InputSwitch
                              label="Adicionar horário de almoço"
                              size="small"
                              onChange={e => {
                                const isEnabled = e.target.checked
                                setLaunchTimeSaturdayEnabled(isEnabled)
                                const newSchedules = values.schedules.map(
                                  (schedule, index) => {
                                    if (schedule.checked && index === 5) {
                                      return {
                                        ...schedule,
                                        startTimeB: isEnabled
                                          ? lunchSaturdayStartTime
                                          : '',
                                        endTimeB: isEnabled
                                          ? lunchSaturdayEndTime
                                          : ''
                                      }
                                    }
                                    return schedule
                                  }
                                )
                                setFieldValue('schedules', newSchedules)
                              }}
                              checked={launchTimeSaturdayEnabled}
                            />
                            {launchTimeSaturdayEnabled && (
                              <div className={classes.inputWrapper}>
                                <InputFieldText
                                  type="time"
                                  value={lunchSaturdayStartTime}
                                  onChange={e => {
                                    const newStartTime = e.target.value
                                    setLunchSaturdayStartTime(newStartTime)
                                    const newSchedules = values.schedules.map(
                                      (schedule, index) =>
                                        schedule.checked && index === 5
                                          ? {
                                              ...schedule,
                                              startTimeB: newStartTime
                                            }
                                          : schedule
                                    )
                                    setFieldValue('schedules', newSchedules)
                                    e.target.blur()
                                  }}
                                  InputLabelProps={{
                                    shrink: true
                                  }}
                                />
                                <span className={classes.textUntil}>até</span>
                                <InputFieldText
                                  type="time"
                                  value={lunchSaturdayEndTime}
                                  onChange={e => {
                                    const newEndTime = e.target.value
                                    setLunchSaturdayEndTime(newEndTime)
                                    const newSchedules = values.schedules.map(
                                      (schedule, index) =>
                                        schedule.checked && index === 5
                                          ? {
                                              ...schedule,
                                              endTimeB: newEndTime
                                            }
                                          : schedule
                                    )
                                    setFieldValue('schedules', newSchedules)
                                    e.target.blur()
                                  }}
                                  InputLabelProps={{
                                    shrink: true
                                  }}
                                />
                              </div>
                            )}
                          </FormControl>
                        </div>
                      )}

                      {showSundayTime && (
                        <div
                          className={classes.boxShowWeekTime}
                          style={{
                            height: launchTimeSundayEnabled ? 'auto' : '120px'
                          }}
                        >
                          <FormControl className={classes.formControl}>
                            <FormLabel
                              component="legend"
                              className={classes.formLabel}
                            >
                              Horário durante os domingos
                            </FormLabel>
                            <div className={classes.inputWrapper}>
                              <InputFieldText
                                type="time"
                                value={sundayStartTime}
                                onChange={e => {
                                  const newStartTime = e.target.value
                                  setSundayStartTime(newStartTime)
                                  const newSchedules = values.schedules.map(
                                    (schedule, index) =>
                                      schedule.checked && index === 6
                                        ? {
                                            ...schedule,
                                            startTimeA: newStartTime
                                          }
                                        : schedule
                                  )
                                  setFieldValue('schedules', newSchedules)
                                  e.target.blur()
                                }}
                                InputLabelProps={{
                                  shrink: true
                                }}
                              />
                              <span className={classes.textUntil}>até</span>
                              <InputFieldText
                                type="time"
                                value={sundayEndTime}
                                onChange={e => {
                                  const newEndTime = e.target.value
                                  setSundayEndTime(newEndTime)
                                  const newSchedules = values.schedules.map(
                                    (schedule, index) =>
                                      schedule.checked && index === 6
                                        ? { ...schedule, endTimeA: newEndTime }
                                        : schedule
                                  )
                                  setFieldValue('schedules', newSchedules)
                                  e.target.blur()
                                }}
                                InputLabelProps={{
                                  shrink: true
                                }}
                              />
                            </div>
                            <InputSwitch
                              label="Adicionar horário de almoço"
                              size="small"
                              onChange={e => {
                                const isEnabled = e.target.checked
                                setLaunchTimeSundayEnabled(isEnabled)
                                const newSchedules = values.schedules.map(
                                  (schedule, index) => {
                                    if (schedule.checked && index === 6) {
                                      return {
                                        ...schedule,
                                        startTimeB: isEnabled
                                          ? lunchSundayStartTime
                                          : '',
                                        endTimeB: isEnabled
                                          ? lunchSundayEndTime
                                          : ''
                                      }
                                    }
                                    return schedule
                                  }
                                )
                                setFieldValue('schedules', newSchedules)
                              }}
                              checked={launchTimeSundayEnabled}
                            />
                            {launchTimeSundayEnabled && (
                              <div className={classes.inputWrapper}>
                                <InputFieldText
                                  type="time"
                                  value={lunchSundayStartTime}
                                  onChange={e => {
                                    const newStartTime = e.target.value
                                    setLunchSundayStartTime(newStartTime)
                                    const newSchedules = values.schedules.map(
                                      (schedule, index) =>
                                        schedule.checked && index === 6
                                          ? {
                                              ...schedule,
                                              startTimeB: newStartTime
                                            }
                                          : schedule
                                    )
                                    setFieldValue('schedules', newSchedules)
                                    e.target.blur()
                                  }}
                                  InputLabelProps={{
                                    shrink: true
                                  }}
                                />
                                <span className={classes.textUntil}>até</span>
                                <InputFieldText
                                  type="time"
                                  value={lunchSundayEndTime}
                                  onChange={e => {
                                    const newEndTime = e.target.value
                                    setLunchSundayEndTime(newEndTime)
                                    const newSchedules = values.schedules.map(
                                      (schedule, index) =>
                                        schedule.checked && index === 6
                                          ? {
                                              ...schedule,
                                              endTimeB: newEndTime
                                            }
                                          : schedule
                                    )
                                    setFieldValue('schedules', newSchedules)
                                    e.target.blur()
                                  }}
                                  InputLabelProps={{
                                    shrink: true
                                  }}
                                />
                              </div>
                            )}
                          </FormControl>
                        </div>
                      )}
                    </Grid>
                  </Grid>
                </Grid>
              </DialogContent>
              <DialogActions>
                <ButtonSecondary
                  onClick={handleClose}
                  label={i18n.t('whatsappModal.buttons.cancel')}
                />
                {/* O botão de salvar chama o submitForm do Formik */}
                <ButtonPrimary
                  loading={loading}
                  onClick={submitForm} // Chama a função de submissão do Formik
                  label="Salvar"
                />
              </DialogActions>
            </Form>
          )
        }}
      </Formik>
    </Dialog>
  )
}

export default ScheduleQueueModal
